import ImageFormController from './image.form.controller';

export default {
    template: require('./image.form.html'),
    controller: ImageFormController
};
